/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Box, Text, Button, Layer, Heading, TextInput } from "grommet"

import { PowerForceShutdown, Power, PowerCycle, Scan, Action, Run, SchedulePlay, ClearOption, Trigger, Search } from 'grommet-icons'

import { TriageTask, uuidv4 } from '../../triage/TriageTaskUtils'
import { envConfig } from '../../../utils/envConfig'
import TTTip from '../../common/TTTip'

export const SendCommand = (appName, commandName, method, submitParam, fileUpload, envSelected, token, addToast, setTaskId = false) => {

    // this send command is the magic buttons on other url pages other than triage
    // this should always be the default t3 url and not from drop down
    const t3_url = envConfig[process.env.REACT_APP_ENVIRONMENT]['t3_url']
    let api = '/api/1/' + appName + '/' + commandName + '/' + envSelected
    let t3 = new TriageTask()
    const submitParamStr = JSON.stringify(submitParam)

    const taskMessageRender = (taskMessageType, appName, method, commandName, submitParamStr, body, taskid) => {

        if (setTaskId !== false) {
            setTaskId(taskid)
        }
        const urlLink = '/triage/showtask/' + taskid

        return (
            <Box>
                <Text size="small">{taskMessageType === "success" ? "Success" : "Error"} Task ({method}) with ID</Text>
                <Text size="xsmall">{taskid}</Text>
                <Text size="small">{appName} - {commandName}</Text>
                <Text size="small">With Parameters</Text>
                <Text size="xsmall">{submitParamStr}</Text>
                <Text size="small">{body}</Text>

                <Box pad="xsmall" width="160px">
                    <Button target="_blank" primary href={urlLink} label={<Text size="12px">Task Result Link</Text>} />
                </Box>

            </Box>
        )
    }

    t3.submit(
        t3_url, token, method, api, submitParam, {}, fileUpload, envSelected
    ).then(
        response => {
            if (response) {
                let taskMessageBody = ''
                let taskMessageID = ''
                let taskMessageType = 'error'
                const taskid_generated = uuidv4()

                if (!response.data.task_id && response.data.error) {
                    // No Task ID and Has ERROR
                    taskMessageBody = response.data.error
                    taskMessageType = 'error'
                    taskMessageID = taskid_generated

                } else if (!response.data.task_id && !response.data.error) {
                    // NO Task ID and No Error
                    taskMessageBody = ""
                    taskMessageType = 'success'
                    taskMessageID = taskid_generated

                } else if (response.data.task_id && response.data.group) {
                    // Insert GroupTask as Backend cannot handle
                    taskMessageBody = ""
                    taskMessageType = 'success'
                    taskMessageID = response.data.task_id
                } else {
                    // Insert into jobtaskdetails (Instant Data)
                    taskMessageBody = ""
                    taskMessageType = 'success'
                    taskMessageID = response.data.task_id
                }

                addToast(taskMessageRender(taskMessageType, appName, method, commandName, submitParamStr, taskMessageBody, taskMessageID), {
                    appearance: taskMessageType,
                    autoDismiss: true,
                })

            }

        }
    )
}

export const CommandFormConfirmation = ({ appName, commandName, envSelected, setIsOpen, setConfirmation, message, params = {} }) => {

    const handleclickYes = () => {
        setIsOpen(false)
        setConfirmation(true)
    }
    const handleclickNo = () => {
        setIsOpen(false)
        setConfirmation(false)
    }

    return (

        <Layer position="center" modal >
            <Box pad="medium" gap="small" width="500px" height="680px" round="medium" align="center">
                <Heading level={4} margin={{ top: "30px", bottom: "15px" }} align="center" color="dark-3" textAlign="center">
                    {message}</Heading>

                <Text size="medium" color="brand" weight="bold" margin={{ top: "15px", bottom: "5px" }}>{appName} - {commandName}</Text>
                {envSelected && <Text size="small" weight="bold">On {envSelected}</Text>}

                {Object.keys(params).length > 0 &&
                    <Text size="small" margin={{ top: "20px" }}>With the Following Params</Text>
                }
                <Box fill="horizontal" background="light-1" margin={{ top: "30px" }}>
                    {Object.keys(params).length > 0 && Object.keys(params).map(param => (
                        <Text weight="bold" size="small" key={param}>{param} : {params[param] === true ? "true" : params[param] === false ? "false" : params[param]}</Text>
                    )
                    )}
                </Box>

                <Box direction="row" margin={{ top: "80px" }}>
                    <Button margin={{ right: "50px" }} label="Yes" primary onClick={handleclickYes} >
                    </Button>
                    <Button color="light-2"
                        onClick={handleclickNo}
                        primary label="No"
                    >
                    </Button>
                </Box>

            </Box>
        </Layer>

    )

}

const ActionPanel = ({ label, icon, setConfirmation, appName, commandName, env, message, token, setValue = null, disabled = false, params = {} }) => {

    const [isOpen, setIsOpen] = useState(false)
    const [tempvalue, settempvalue] = useState(commandName === 'order_search' ? '120' : '');
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const [reason, setReason] = useState("")
    const [openError, setOpenError] = useState(false)

    const handleClick = () => {
        if (setValue && !reason.toUpperCase().includes("MON-") &&
            !reason.toUpperCase().includes("TTSD-") &&
            !reason.toUpperCase().includes("CHG") &&
            !reason.toUpperCase().includes("DEB-") &&
            !reason.toUpperCase().includes("PRB") &&
            !reason.toUpperCase().includes("INC") &&
            !reason.toUpperCase().includes("TTCS")
        ) {
            setOpenError(true)
            setIsOpen(false)
        } else {
            setOpenError(false)
            setIsOpen(true)
        }
    }

    const toggleView = () => {
        setOpenError(!openError)
    }

    return (
        <>{!liteMode &&
            <>
                <Box pad="xsmall" round="3px" margin={{ top: "3px" }}
                    border={{ "color": "brand", "size": "xsmall", "style": "solid", "side": "all" }}
                >
                    <Button onClick={handleClick} disabled={disabled}
                        hoverIndicator={{ color: "dark-1", opacity: "weak" }}
                    >
                        <Box direction="row" gap="xsmall">
                            {icon}
                            <Text size="xsmall">{label}</Text>
                        </Box>
                    </Button>

                    {!disabled && setValue &&
                        <Box pad="1px">
                            <TTTip hoverMessage="MON/TTSD/DEB/PRB/INC/TTCS" position="bottom">
                                <TextInput
                                    style={{ height: "20px" }}
                                    placeholder={<Text size="xsmall">Valid Ticket</Text>}
                                    onChange={event => {
                                        setValue(event.target.value)
                                        setReason(event.target.value)
                                        settempvalue(event.target.value)
                                    }
                                    }
                                    size="xsmall"
                                    value={tempvalue}
                                />
                            </TTTip>
                        </Box>
                    }
                    {openError &&
                        <Layer position="center" modal
                            onEsc={() => {
                                toggleView()
                            }}
                            onClickOutside={() => {
                                toggleView()
                            }}
                        >
                            <Box pad='large'>
                                <Text size="medium" color="ttdown" weight="bold" margin={{ top: "15px", bottom: "5px" }}>Please provide a MON/TTSD/DEB/PRB/INC/TTCS for this action and try again</Text>
                            </Box>
                        </Layer>
                    }

                </Box>
                {isOpen && (
                    <CommandFormConfirmation
                        appName={appName}
                        commandName={commandName}
                        envSelected={env}
                        setIsOpen={setIsOpen}
                        setConfirmation={setConfirmation}
                        message={message}
                        params={params}
                    />
                )}
            </>
        }
        </>
    )
}

export const ActionPanelDrain = ({ appName, commandName, host, label, env, token, addToast, backend = "" }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')

    let param = {
        target: host,
        mode: "DRAIN",
        force: true,
        reason: jira
    }
    if (backend) {
        param = {
            target: host,
            mode: "DRAIN",
            force: true,
            backend: backend,
            reason: jira
        }
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<PowerForceShutdown size="16px" color="ttdown" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to Drain " + host}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelOCDrain = ({ appName, commandName, host, label, env, token, addToast, clusterName }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: host,
        drain: true,
        status: true,
        exchange: clusterName.replace("oc-", ""),
        reason: jira
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<PowerForceShutdown size="16px" color="ttdown" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to Drain " + host}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelZkData = ({ appName, commandName, host, label, env, token, addToast, zk_app_name, setTaskId }) => {

    //const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: host,
        zk_app_name: zk_app_name,
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast,
            setTaskId
        )
    }

    // Run Once On Open
    useEffect(() => {
        handleClickActions()
    }, [])

    return (
        <Box />
    )
}

export const ActionPanelTTService = ({ appName, commandName, method, host, service_name, label, env, token, addToast, icon, disabled = false }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')

    const handleClickActions = () => {

        let param = {}

        if (jira.length > 0) {
            param = {
                name: host,
                action: commandName,
                service: service_name,
                jira: jira,
                reason: jira
            }
        } else {
            param = {
                name: host,
                action: commandName,
                service: service_name
            }
        }

        SendCommand(appName,
            commandName,
            method,
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label}
            icon={icon}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            host={host}
            service_name={service_name}
            disabled={disabled}
            message={"Are you sure you want to run command " + commandName + " on service " + service_name + (jira && jira.length > 0 ? " relating to " + jira : "")}
            token={token}
            setValue={setJira}
        />
    )
}

export const ActionPanelUnDrain = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: host,
        mode: "READY",
        force: true,
        reason: jira
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Power size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to UnDrain " + host}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelOCUnDrain = ({ appName, commandName, host, label, env, token, addToast, clusterName }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: host,
        drain: false,
        status: true,
        exchange: clusterName.replace("oc-", ""),
        reason: jira
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Power size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to UnDrain " + host}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelOCTTUS = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')

    const handleClickActions = () => {
        const param = {
            target: host,
            reason: jira
        }
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<PowerCycle size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the TTUS Cache on " + host}
            token={token}
            setValue={setJira}
        />
    )
}

export const ActionPanelOCRebalance = ({ appName, commandName, host, label, env, token, addToast, market }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: market,
        reason: jira
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Action size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to re-balance the connections in the market " + market}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelOCRefreshDiag = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)

    const handleClickActions = () => {
        const param = {
            send_diagnostics: true
        }
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Scan size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the All the OC Diagnostics Checks?"}
            token={token}
        />
    )
}

export const ActionPanelBouncerRefreshDiag = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)
    const param = {
        datacenters: "all",
        compare_with_ttus: true,
        send_diagnostics: true,
        check_dedicated: true
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Scan size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the All the Bouncer Diagnostics Checks? (Takes 5 mins to Run)"}
            token={token}
            params={param}
        />
    )
}

export const ActionPanelBouncerClearPending = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')

    const handleClickActions = () => {
        const param = {
            target: host,
            reason: jira
        }
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<ClearOption size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to clear pending orders on " + host + "?"}
            token={token}
            setValue={setJira}
        />
    )
}

export const ActionPanelGCGraceRefreshDiag = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)

    const handleClickActions = () => {
        const param = {
        }
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Scan size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the Cassandra GCGrace Checks? (Takes 2 mins to Run)"}
            token={token}
        />
    )
}

export const ActionPanelR53RefreshDiag = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)

    const handleClickActions = () => {
        const param = {
            app: "all",
        }
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Scan size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the AWS R53 Checks?"}
            token={token}
        />
    )
}

export const ActionPanelIfoa = ({ appName, commandName, order_id, cl_order_id, label, env, token, addToast, setTaskId, minutesAgo }) => {

    const [confirmation, setConfirmation] = useState(false)
    const param = {
        order_id: order_id,
        cl_order_id: cl_order_id,
        minutes: minutesAgo
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast,
            setTaskId
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Search size="16px" color="black" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to get elk logs for the below"}
            token={token}
            params={param}
        />
    )
}

export const ActionPanelPSRefreshDiag = ({ appName, commandName, host, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)

    const handleClickActions = () => {
        const param = {
            send_diagnostics: true
        }
        SendCommand(appName,
            commandName,
            "GET",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Scan size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to refresh the All the PS Client Data? (Takes 8 mins to Run Completely)"}
            token={token}
        />
    )
}

export const ActionPanelPSEvacuate = ({ appName, commandName, instanceId, label, env, token, addToast }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')
    let param = {
        target: instanceId,
        beacon: "drain_and_evacuate",
        reason: jira
    }
    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Run size="16px" color="ttwarning" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to Drain & Evacuate price clients from " + instanceId}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelPSBeaconOff = ({ appName, commandName, instanceId, label, env, token, addToast }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    let param = {
        target: instanceId,
        beacon: "off",
        reason: jira
    }
    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Run size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want send Beacon Off to " + instanceId}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelPSDR = ({ appName, commandName, instanceId, label, env, token, addToast, serviceName }) => {

    const [confirmation, setConfirmation] = useState(false)
    const [jira, setJira] = useState('')

    const param = {
        target: instanceId,
        beacon: "force_all",
        reason: jira
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Trigger size="16px" color="ttdown" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to Trigger DR for " + serviceName + " " + instanceId}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}

export const ActionPanelPSDRRevert = ({ appName, commandName, instanceId, label, env, token, addToast, serviceName }) => {

    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: instanceId,
        beacon: "force_primary",
    }

    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<Trigger size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to Revert DR for " + serviceName + " " + instanceId}
            token={token}
            params={param}
        />
    )
}

export const ActionPanelMarketCheckout = ({ env, token, addToast, label, dr, appName = "checkout", commandName = "market" }) => {
    const [confirmation, setConfirmation] = useState(false)

    const handleClickActions = () => {
        const param = {}
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={<SchedulePlay size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to run Market Checkouts?"}
            token={token}
        />
    )

}

export const ActionPanelFIXDrain = ({ appName, commandName, instanceId, label, env, token, addToast, prevent_new_connection, session_type }) => {

    const [jira, setJira] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const param = {
        target: instanceId,
        prevent_new_connection: prevent_new_connection,
        session_type: session_type,
        reason: jira
    }
    const handleClickActions = () => {
        SendCommand(appName,
            commandName,
            "POST",
            param,
            {},
            env,
            token,
            addToast
        )
    }

    useEffect(() => {
        if (confirmation) {
            handleClickActions()
        }
    }, [confirmation])

    return (
        <ActionPanel
            label={label} icon={prevent_new_connection ? <PowerForceShutdown size="16px" color="ttdown" /> : <Power size="16px" color="ttok" />}
            setConfirmation={setConfirmation}
            appName={appName}
            commandName={commandName}
            env={env}
            message={"Are you sure you want to " + (prevent_new_connection ? "Drain" : "UnDrain") + " FIX Node with Instance " + instanceId}
            token={token}
            params={param}
            setValue={setJira}
        />
    )
}
